import { ModuleSection } from './module-section';
import { DashboardMockup } from './dashboard-mockup';
import { ProcessosMockup } from './processos-mockup';
import { IntimacoesMockup } from './intimacoes-mockup';
import { AtividadesMockup } from './atividades-mockup';
import { AgendaMockup } from './agenda-mockup';
import { DocumentosMockup } from './documentos-mockup';
import { FinanceiroMockup } from './financeiro-mockup';
import { RelatoriosMockup } from './relatorios-mockup';

export function LandingModuleShowcase() {
  return (
    <div
      style={{
        position: 'relative',
        zIndex: 1,
      }}
    >
      {/* Divisor sutil antes das secoes de modulo */}
      <div
        aria-hidden="true"
        style={{
          maxWidth: 1180,
          margin: '0 auto 0',
          padding: '0 24px',
        }}
      >
        <div
          style={{
            height: 1,
            background:
              'linear-gradient(90deg, transparent 0%, rgba(109,40,217,0.3) 30%, rgba(168,85,247,0.3) 70%, transparent 100%)',
          }}
        />
      </div>

      <ModuleSection
        id="dashboard"
        kicker="DASHBOARD CUSTOMIZADO"
        title="Seu painel, do seu jeito"
        desc="Widgets de clientes, processos, prazos, financeiro e intimações que você arrasta, redimensiona e reorganiza. Cada pessoa do escritório monta a visão que importa pra ela, logo na abertura."
      >
        <DashboardMockup />
      </ModuleSection>

      <ModuleSection
        id="processos"
        kicker="PROCESSOS"
        title="Cada processo sob controle"
        desc="Capa, partes, movimentações, documentos, tarefas e financeiro num só lugar. Preencha pelo número do CNJ e puxe os dados direto do tribunal, inclusive de processos em segredo de justiça."
        reverse
      >
        <ProcessosMockup />
      </ModuleSection>

      <ModuleSection
        id="intimacoes"
        kicker="INTIMAÇÕES"
        title="A intimação chega até você"
        desc="Caixa de entrada com tudo do DJEN. Filtra por OAB monitorada e tribunal, vincula ao processo e já gera a tarefa com o prazo fatal calculado."
      >
        <IntimacoesMockup />
      </ModuleSection>

      <ModuleSection
        id="atividades"
        kicker="ATIVIDADES E PRAZOS"
        title="Nenhum prazo passa batido"
        desc="Tarefas com responsáveis, compromissos e prazos fatais em destaque. Widgets de atividade e produtividade mostram o que está pendente, atrasado e resolvido."
        reverse
      >
        <AtividadesMockup />
      </ModuleSection>

      <ModuleSection
        id="agenda"
        kicker="AGENDA"
        title="A agenda do escritório inteiro"
        desc="Visão de mês, semana e dia, com filtros por responsável e por status. Compromissos e prazos lado a lado, e sincronização com o Google Agenda para tudo aparecer onde você já olha."
      >
        <AgendaMockup />
      </ModuleSection>

      <ModuleSection
        id="documentos"
        kicker="DOCUMENTOS"
        title="Modelos viram documentos em segundos"
        desc="Biblioteca de modelos com variáveis do cliente e do processo. Gere a peça preenchida, edite num editor moderno e envie para o cliente assinar por e-mail."
        reverse
      >
        <DocumentosMockup />
      </ModuleSection>

      <ModuleSection
        id="financeiro"
        kicker="FINANCEIRO"
        title="A saúde financeira do escritório"
        desc="Saldo, receita e despesa previstas, pagamentos atrasados e o fluxo dos últimos meses. Lançamentos com parcelas, categorias e contas, e cobrança recorrente automática."
      >
        <FinanceiroMockup />
      </ModuleSection>

      <ModuleSection
        id="relatorios"
        kicker="RELATÓRIOS"
        title="Relatórios que trabalham por você"
        desc="Não é o relatório de sempre. Monte relatórios personalizados e programe o envio automático para o cliente ou para a equipe, na frequência que você definir."
        reverse
      >
        <RelatoriosMockup />
      </ModuleSection>
    </div>
  );
}
